import { createContext, useContext } from "react";

type EventHandler = (payload: unknown) => void;

export interface WsContextShape {
  subscribe: (eventType: string, handler: EventHandler) => () => void;
  send: (message: unknown) => void;
  // Last-known socket readyState === OPEN. False before the first connect too.
  connected: boolean;
  // Unix ms timestamp when the socket last closed; null while connected or
  // before the very first connect attempt finished. Used by the connection
  // banner to wait ~3s before announcing trouble.
  disconnectedSince: number | null;
}

export const WsContext = createContext<WsContextShape | null>(null);

export function useWsContext(): WsContextShape {
  const ctx = useContext(WsContext);
  if (!ctx) throw new Error("useWsContext must be used inside <WebSocketProvider>");
  return ctx;
}
